"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTableCell = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledTableCell = _styledComponents["default"].td.withConfig({
  displayName: "TableCellstyles__StyledTableCell",
  componentId: "sc-1dct85i-0"
})(["", " ", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    tl\n    ", "\n  "])), function (_ref) {
  var _table$size$size, _table$type$type;

  var table = _ref.theme.table,
      size = _ref.size,
      type = _ref.type;
  return "\n      ".concat((_table$size$size = table.size[size]) === null || _table$size$size === void 0 ? void 0 : _table$size$size.cellSize, "\n      ").concat((_table$type$type = table.type[type]) === null || _table$type$type === void 0 ? void 0 : _table$type$type.cell.tachyons, "\n    ");
}), function (_ref2) {
  var _table$type$type2;

  var table = _ref2.theme.table,
      type = _ref2.type;
  return "\n      ".concat((_table$type$type2 = table.type[type]) === null || _table$type$type2 === void 0 ? void 0 : _table$type$type2.cell.css, "\n  ");
});

exports.StyledTableCell = StyledTableCell;